import { ModelFormValues } from '../components/ModelForm';

type ValidationErrors = Record<string, string[] | undefined>;

const MAX_STOCKING_SPEC_LENGTH = 500;

export const validateModel = async (
  values: ModelFormValues,
): Promise<ValidationErrors> => {
  const errors: ValidationErrors = {};
  if (!values.name) {
    errors.name = ['The name is required'];
  }
  if (!values.subdivisionId) {
    errors.subdivisionId = ['The Subdivision is required'];
  }
  if (!values.externalId) {
    errors.externalId = ['The External Id is required'];
  }
  if (!values.description) {
    errors.description = ['The Description is required'];
  }
  if (
    values.stockingSpec &&
    values.stockingSpec.length > MAX_STOCKING_SPEC_LENGTH
  ) {
    errors.stockingSpec = [
      'Stocking Spec must be shorter than or equal to 500 characters',
    ];
  }
  if (
    values.hasTrimOptions &&
    values.defaultTrimOptionCost !== '' &&
    Number(values.defaultTrimOptionCost) <= 0
  ) {
    errors.defaultTrimOptionCost = ['Enter a positive value'];
  }
  return errors;
};
